// extracted by mini-css-extract-plugin
export default {"wrapper":"vacany-info_wrapper__4pH6F","container":"vacany-info_container__My5Dj"};